export default __webpack_public_path__ + "static/stickers-8ec1c063041ac5cb917590e99eefa815.png";